import type { DataQuery } from "./form-definition-core.types";

/**
 * Appends `EntityDataQueries` in bracket notation for ASP.NET Core model binding
 * (e.g. `EntityDataQueries[0].comparisonType=1`).
 */
export function appendEntityDataQueriesToQueryParams(
	flat: Record<string, string | number | boolean | string[] | undefined>,
	queries: DataQuery[] | undefined,
): void {
	if (!queries?.length) return;
	for (let i = 0; i < queries.length; i++) {
		const q = queries[i];
		const prefix = `EntityDataQueries[${i}]`;
		if (q.columnDefinitionId != null && q.columnDefinitionId !== "") {
			flat[`${prefix}.columnDefinitionId`] = q.columnDefinitionId;
		}
		if (q.name != null && q.name !== "") {
			flat[`${prefix}.name`] = q.name;
		}
		flat[`${prefix}.comparisonType`] = q.comparisonType;
		if (q.textValue != null && q.textValue !== "") {
			flat[`${prefix}.textValue`] = q.textValue;
		}
		if (q.numericValue !== undefined && q.numericValue !== null) {
			flat[`${prefix}.numericValue`] = q.numericValue;
		}
		if (q.dateValue != null && q.dateValue !== "") {
			flat[`${prefix}.dateValue`] = q.dateValue;
		}
	}
}
